import React, { useState } from "react";
import { Route, Routes } from "react-router-dom";

import Index from "../pages/inventory/index";
import WorkshopAdminMasterLayout from "../layout/WorkshopAdminMasterLayout";

// console.log("WorkshopAdminPrivateRoutes");
const WorkshopAdminPrivateRoutes = () => {
        const [liftingName, setLiftingName] = useState<any>('')

    return (
        <>
            <Routes>
                        <Route element={<WorkshopAdminMasterLayout liftingName={liftingName}/>}>

                    <Route path="vehicle/*" element={<Index />}/>
                
                </Route>

                
            </Routes>
        </>
    );
};

export default WorkshopAdminPrivateRoutes;